export class DisplayDirection {

    public static RTL = 'rtl';
    public static LTR = 'ltr';
}